const state = {
  user: {},
  status: false
};

const mutations = {
  onAuthStateChanged(state, user) {
    state.user = user;
  },
  onUserStatusChanged(state, status) {
    state.status = status;
  },
  clear(state) {
    state.user = {};
    state.status = false;
  }
};
const actions = {
  onAuthStateChanged({ commit }, user) {
    const { uid } = user;
    commit("onAuthStateChanged", { uid });
  },
  onUserStatusChanged({ commit }, status) {
    commit("onUserStatusChanged", status);
  }
};
const getters = {
  user(state) {
    return state.user;
  },
  isSignedIn(state) {
    return state.status;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
